export default "__VITE_ASSET__CCyhNYX4__"